// src/contexts/VersionContext.tsx
import type React from 'react'
import { createContext, type ReactNode, useEffect, useState } from 'react'
import { useCC01VersionGet } from '../hooks/useCC01VersionGet'

type Version = { version: string }

export const VersionContext = createContext<Version>({ version: '' })

export const VersionProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [version, setVersion] = useState<Version>({ version: '' })

  const cc01 = useCC01VersionGet()

  useEffect(() => {
    const fetchVersion = async () => {
      try {
        const result = await cc01.execVersionGet()
        if (result.success) {
          setVersion({ version: result.info?.version || '' })
        }
      } catch (err) {
        console.error('Version fetch error:', err)
      }
    }
    fetchVersion()
  }, [])

  return <VersionContext.Provider value={version}>{children}</VersionContext.Provider>
}
